/**
 * Add global attributes to all blocks
 */

wp.hooks.addFilter('blocks.registerBlockType', 'faqmate/attribute/global', function (settings, name) {
    if (name.includes('faqmate/')) {
        settings.attributes = {
            ...settings.attributes,
            uniqueId: {
                type: 'string'
            },
            preview: {
                type: 'boolean',
                default: false
            },
            resMode: {
                type: 'string',
                default: 'Desktop'
            },
            blockStyle: {
                type: 'object'
            }
        };
    }

    return settings;
});
